export default{
    ERROR_CODES(state, payload){
        state[payload.key] = payload.value;
    }
}